import { createApi } from '@reduxjs/toolkit/query/react'
import { BaseRequest, BaseResponse } from '../models'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'

const _BASE_URL = import.meta.env.REACT_APP_AI_BASE_URL!

export interface GetPromptSegmentsRequest extends BaseRequest {
  type?: string
}

export interface PromptSegment {
  id: string
  accountId: string | null
  type: string
  title: string
  description: string
}

const transformResponse = <T>(response: BaseResponse<T>) => response.data

export const promptSegmentApi = createApi({
  reducerPath: 'promptSegmentApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  tagTypes: ['PromptSegment'],
  endpoints: (builder) => ({
    getPromptSegments: builder.query<PromptSegment[], GetPromptSegmentsRequest>({
      query: (request) => {
        return {
          url: `/accounts/${request.accountId}/prompt-segments/`,
          params: {
            type: request.type,
          },
        }
      },
      transformResponse,
      providesTags: ['PromptSegment'],
    }),
  }),
})

export const { useGetPromptSegmentsQuery } = promptSegmentApi
